import React, { useEffect } from 'react';
import nalin from '../../src/assets/img/speakers/nalin.webp'
import shivendra from '../../src/assets/img/speakers/shivendra.jpeg'
import devyani from '../../src/assets/img/speakers/devyani.jpg'
import gaurav from '../../src/assets/img/speakers/gaurav.jpeg'
import suhas from '../assets/img/speakers/suhas.avif'
import sujeet from '../../src/assets/img/speakers/sujeet.png'
import arpit from '../../src/assets/img/speakers/arpit.png'
import nithya from '../../src/assets/img/speakers/nithya.jpg'
import gunjan from '../../src/assets/img/speakers/gunjan.png'
import ashish from '../../src/assets/img/speakers/ashish.jpg'
import kaus from '../../src/assets/img/speakers/kaus.webp'



const recent_speaker_card = [
  { img: nalin, id: 8, name: "Nalin Singhal", position: "Chairman and Managing Director, BHEL" },
  { img: ashish, id: 6, name: "Aasheish Sharma", position: "Lead Actor, Siya ke Ram" },
  { img: shivendra, id: 2, name: "Shivendra Pratap Kanwar", position: "Fomer Commanding Officer, Armed Forces", },
  { img: devyani, id: 3, name: "Devyani Shorey", position: "Lead Actor, Mismatched" },
  { img: gaurav, id: 4, name: "Gaurav Sen", position: "Youtuber, Founder at InterviewReady" },
  { img: suhas, id: 5, name: "Suhas Yathiraj", position: "IAS Officer, Paralympics Silver Medallist" },
  { img: kaus, id: 156, name: "Kaushalya Choudhary", position: "Youtuber, Cook, Social Worker" },
  { img: sujeet, id: 7, name: "Sujeet Singh", position: "Founder, Neso Academy" },
  { img: arpit, id: 1, name: "Arpit Mangal", position: "Fitness Trainer, Youtuber" },
  { img: nithya, id: 1, name: "Nithya Rajendran", position: "Singer, Composer and Carnatic Musician" },
  { img: gunjan, id: 1, name: "Dr. Gunjan Malhotra", position: "Veteran Gynaecologist, Mrs. India Sub-continent 2024" },
];

const RecentSpeaker = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
    <section id="team" className="team mt-5">
        <div className="container">
          <div className="section-title">
            <h2 className=''>
             <span className="text-white">  OUR NEW</span>  SPEAKERS
            </h2>
          </div>
          <div className="row justify-content-center p-5">
            {recent_speaker_card.map((e) => (
              <div className="col-lg-3 col-md-6 d-flex align-items-stretch" key={e.id}>
                <div className="member">
                  <div className="member-img">
                    <img src={e.img} className="img-fluid" alt="" />
                  </div>
                  <div className="member-info">      
                    <h4 className="text-center">{e.name}</h4>
                    <span className="text-center">{e.position}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default RecentSpeaker